import React from 'react';

import {
  DescriptionList,
  DescriptionItem,
  Typography,
} from '@gogame/components';

import AdditionalSpendFee from '../AdditionalSpendFee';

const GeneralSection = ({ data, onOpenCompany, onOpenPartner }) => (
  <DescriptionList disableGutters data={data}>
    <DescriptionItem
      label={'Partner company'}
      field={'partnerCompany'}
      type={'link'}
      linkLabelField={'name'}
      onValueClick={onOpenCompany}
    />
    <DescriptionItem
      label={'Business partner'}
      field={'businessPartner'}
      type={'link'}
      linkLabelField={'name'}
      onValueClick={onOpenPartner}
    />
    <DescriptionItem label={'Network'} field={'network'} />
    <DescriptionItem label={'Traffic types'} field={'trafficTypes'} />
    <DescriptionItem label={'Channel type'} field={'channel.type.name'} />
    <DescriptionItem label={'Channel'} field={'channel.name'} />
    <DescriptionItem label={'Expense type'} field={'expenseType'} />
    <DescriptionItem field={'revenueShare'} label={'Revenue Share'} />
    <DescriptionItem
      field={'additionalFee'}
      label={'Additional spend fee'}
      type={({ value }) => {
        return (
          <Typography>
            <AdditionalSpendFee
              period={value.period}
              taxFeePercent={value.taxFeePercent}
            />
          </Typography>
        );
      }}
    />
    <DescriptionItem
      label={'Media Source'}
      field={'mediaSource.name'}
      type={'text'}
    />
    <DescriptionItem label={'Spend source'} field={'spendSource.name'} />
    <DescriptionItem
      label={'Keywords in email subject'}
      field={'invoiceProcessingRuleKeywords'}
    />
    <DescriptionItem
      label={'Invoice sender domain'}
      field={'invoiceProcessingRuleSenderDomain'}
    />
  </DescriptionList>
);

export default GeneralSection;
